const klarnaPayments = require('./klarnaPayments');

/**
 * Validate the payment by means of Klarna if it is selected as payment method.
 *
 * Side effects: disable the place order button.
 *
 * @example
 * * Success response: The purchase is approved.
 *   { approved: true }
 * * Fixable error response: The customer needs to adjust and try again.
 *   { approved: false, error: true }
 * * Error response: The purchase is not approved and you can't display Klarna
 *   as a payment option.
 *   { approved: false, error: true }
 * * Back to form: Canceled auth
 *   { approved: false, error: false }
 * * Ignore the validation because Klarna is not selected
 *   { ignore: true }
 * @returns {Promise.<Object.<string, boolean>>} Validation of the payment
 * ({ approved, error, ignore})
 * @see https://docs.klarna.com/klarna-payments/integrate-with-klarna-payments/step-2-check-out/22-get-authorization/
 */
function validatePayment() {
  if ($('#selectedPaymentOption').val() === 'Klarna') {
    const placeOrderButton = document.querySelector('.place-order-btn');
    if (placeOrderButton === null) {
      return Promise.reject(new Error('Place order button not found'));
    }

    placeOrderButton.disabled = true;
    return klarnaPayments.authorize();
  }

  return Promise.resolve({ ignore: true });
}

module.exports = {
  methods: {
    validatePayment,
  },
};
